var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pdp-grid" }, [
    _c("div", { staticClass: "pdp-grid__header" }, [
      _c("div", { staticClass: "pdp-grid__count" }, [
        _c("b", [_vm._v(_vm._s(_vm.tiles.length))]),
        _vm._v(
          " " + _vm._s(_vm.tiles.length === 1 ? "image" : "images") + "\n      "
        ),
        _vm.generatingCount > 0
          ? _c("span", { staticClass: "pdp-grid__generating" }, [
              _vm._v(" · " + _vm._s(_vm.generatingCount) + " generating"),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pdp-grid__actions" }, [
        _vm.showStop
          ? _c(
              "button",
              {
                staticClass: "pdp-grid__stop",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.act("pdp_grid_stop")
                  },
                },
              },
              [_c("i", { staticClass: "bi bi-x-lg" }), _vm._v(" Stop\n      ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "pdp-grid__btn",
            attrs: { type: "button", disabled: !_vm.canCreate },
            on: {
              click: function ($event) {
                return _vm.act("create_pdp_mixed_layout:false")
              },
            },
          },
          [_vm._v("\n        Create Layout\n      ")]
        ),
        _vm._v(" "),
        _vm.grid.hasAiOrScene
          ? _c(
              "button",
              {
                staticClass: "pdp-grid__btn pdp-grid__btn--primary",
                attrs: { type: "button", disabled: !_vm.canCreate },
                on: {
                  click: function ($event) {
                    return _vm.act("create_pdp_mixed_layout:true")
                  },
                },
              },
              [_vm._v("\n        Create Editable Layout\n      ")]
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _vm.selectedTile
      ? _c("div", { staticClass: "pdp-grid__viewer" }, [
          _c(
            "div",
            {
              staticClass: "pdp-grid__stage",
              class: `pdp-grid__stage--${_vm.selectedTile.state}`,
            },
            [
              _c(
                "span",
                {
                  staticClass: "pdp-grid__badge",
                  class: {
                    "pdp-grid__badge--gallery":
                      _vm.selectedTile.mode === "gallery",
                    "pdp-grid__badge--plain": _vm.isUseAsIs(_vm.selectedTile),
                  },
                },
                [_vm._v(_vm._s(_vm.badgeText(_vm.selectedTile)))]
              ),
              _vm._v(" "),
              _vm.selectedTile.state === "configuring"
                ? _c("div", { staticClass: "pdp-grid__configure-cta" }, [
                    _c("i", { staticClass: "bi bi-magic" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "pdp-grid__stage-label" }, [
                      _vm._v(_vm._s(_vm.selectedTile.label)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "pdp-grid__stage-btn",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.configOpen = true
                          },
                        },
                      },
                      [_vm._v("\n          Set up image\n        ")]
                    ),
                  ])
                : _vm.selectedTile.state === "done" && _vm.selectedTile.url
                ? [
                    _c("img", {
                      staticClass: "pdp-grid__stage-img",
                      attrs: {
                        src: _vm.selectedTile.url,
                        alt: _vm.selectedTile.label,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.openTile(_vm.selectedTile)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.selectedTile.overlayUrl
                      ? _c("img", {
                          key: _vm.selectedTile.overlayUrl,
                          staticClass: "pdp-grid__stage-overlay",
                          attrs: {
                            src: _vm.selectedTile.overlayUrl,
                            alt: "Product",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedTile._mrhiCallouts &&
                    _vm.selectedTile._mrhiCallouts.type === "cambridge"
                      ? _c("div", { staticClass: "pdp-grid__callouts" }, [
                          _c(
                            "div",
                            { staticClass: "pdp-grid__callout-flavor" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.selectedTile._mrhiCallouts.flavorText
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pdp-grid__callout-count" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.selectedTile._mrhiCallouts.countText
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]
                : _c("div", { staticClass: "pdp-grid__placeholder" }, [
                    _c("i", {
                      staticClass: "bi bi-stars",
                      class: {
                        "pdp-grid__spark--active":
                          _vm.selectedTile.state === "generating" ||
                          _vm.selectedTile.state === "regenerating",
                        "pdp-grid__spark--queued":
                          _vm.selectedTile.state === "queued" ||
                          _vm.selectedTile.state === "stopped",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "pdp-grid__stage-label" }, [
                      _vm._v(_vm._s(_vm.selectedTile.label)),
                    ]),
                    _vm._v(" "),
                    _vm.selectedTile.state === "skipped" ||
                    _vm.selectedTile.state === "stopped"
                      ? _c("span", { staticClass: "pdp-grid__stage-state" }, [
                          _vm._v(
                            _vm._s(
                              _vm.selectedTile.state === "stopped"
                                ? "Stopped"
                                : "Skipped"
                            )
                          ),
                        ])
                      : _vm._e(),
                  ]),
              _vm._v(" "),
              _vm.selectedTile.state === "error"
                ? _c("div", { staticClass: "pdp-grid__stage-error" }, [
                    _vm._v("\n        Generation failed\n        "),
                    _c(
                      "button",
                      {
                        staticClass: "pdp-grid__stage-btn",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.act(
                              `pdp_grid_retry:${_vm.selectedTile.rowIndex}`
                            )
                          },
                        },
                      },
                      [_vm._v("\n          Retry\n        ")]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedTile.state === "done" && !_vm.grid.stopped
                ? _c("div", { staticClass: "pdp-grid__stage-tools" }, [
                    _c(
                      "button",
                      {
                        staticClass: "pdp-grid__stage-download",
                        attrs: { type: "button", title: "Download image" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.downloadTile(_vm.selectedTile)
                          },
                        },
                      },
                      [_c("i", { staticClass: "bi bi-download" })]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "pdp-grid__stage-actions" }, [
                      _vm.canToggleProductMode(_vm.selectedTile)
                        ? _c("div", { staticClass: "pdp-grid__mode" }, [
                            _c(
                              "button",
                              {
                                staticClass: "pdp-grid__mode-btn",
                                class: {
                                  "is-active":
                                    _vm.tileProductMode(_vm.selectedTile) ===
                                    "separate",
                                },
                                attrs: {
                                  type: "button",
                                  title:
                                    "Layered: regenerates this image with a clean background (no product), then adds the product as a separate, editable layer when you create the layout.",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.act(
                                      `pdp_grid_mode:${_vm.selectedTile.rowIndex}:separate`
                                    )
                                  },
                                },
                              },
                              [_vm._v("\n              Layered\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "pdp-grid__mode-btn",
                                class: {
                                  "is-active":
                                    _vm.tileProductMode(_vm.selectedTile) ===
                                    "integrated",
                                },
                                attrs: {
                                  type: "button",
                                  title:
                                    "Static: regenerates this image with the product composited in (flat, not an editable layer).",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.act(
                                      `pdp_grid_mode:${_vm.selectedTile.rowIndex}:integrated`
                                    )
                                  },
                                },
                              },
                              [_vm._v("\n              Static\n            ")]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "pdp-grid__stage-btn",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.act(
                                `pdp_grid_regenerate:${_vm.selectedTile.rowIndex}`
                              )
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "bi bi-arrow-counterclockwise",
                          }),
                          _vm._v(" Regenerate\n          "),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "pdp-grid__stage-btn pdp-grid__stage-btn--icon",
                          attrs: { type: "button", title: "Remove this image" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.act(
                                `pdp_grid_skip:${_vm.selectedTile.rowIndex}`
                              )
                            },
                          },
                        },
                        [_c("i", { staticClass: "bi bi-x-lg" })]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "pdp-grid__strip" }, [
            _c(
              "div",
              { staticClass: "pdp-grid__strip-scroll" },
              _vm._l(_vm.tiles, function (tile, idx) {
                return _c(
                  "button",
                  {
                    key: tile.rowIndex,
                    staticClass: "pdp-grid__thumb",
                    class: { "is-selected": idx === _vm.selectedIndex },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.selectTile(idx)
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "pdp-grid__thumb-box",
                        class: `pdp-grid__thumb-box--${tile.state}`,
                      },
                      [
                        tile.state === "done" && tile.url
                          ? [
                              _c("img", {
                                staticClass: "pdp-grid__thumb-img",
                                attrs: { src: tile.url, alt: tile.label },
                              }),
                              _vm._v(" "),
                              tile.overlayUrl
                                ? _c("img", {
                                    key: tile.overlayUrl,
                                    staticClass: "pdp-grid__thumb-overlay",
                                    attrs: {
                                      src: tile.overlayUrl,
                                      alt: "Product",
                                    },
                                  })
                                : _vm._e(),
                            ]
                          : tile.state === "configuring"
                          ? _c("i", {
                              staticClass:
                                "bi bi-magic pdp-grid__thumb-configuring",
                            })
                          : tile.state === "error"
                          ? _c("i", {
                              staticClass:
                                "bi bi-exclamation-triangle pdp-grid__thumb-error",
                            })
                          : tile.state === "skipped" || tile.state === "stopped"
                          ? _c(
                              "span",
                              { staticClass: "pdp-grid__thumb-skipped" },
                              [
                                _vm._v(
                                  _vm._s(
                                    tile.state === "stopped"
                                      ? "Stopped"
                                      : "Skipped"
                                  )
                                ),
                              ]
                            )
                          : _c("span", {
                              staticClass: "pdp-grid__thumb-spinner",
                            }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "pdp-grid__thumb-label" }, [
                      _vm._v(_vm._s(tile.label)),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.addableTypes.length
              ? _c(
                  "div",
                  { staticClass: "pdp-grid__thumb pdp-grid__thumb--add" },
                  [
                    _c(
                      "button",
                      {
                        ref: "addTrigger",
                        staticClass:
                          "pdp-grid__thumb-box pdp-grid__add-trigger",
                        class: { "is-open": _vm.addableTypesOpen },
                        attrs: { type: "button", title: "Add image type" },
                        on: { click: _vm.toggleAddDropdown },
                      },
                      [_c("i", { staticClass: "bi bi-plus-lg" })]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "pdp-grid__thumb-label" }, [
                      _vm._v("Add"),
                    ]),
                    _vm._v(" "),
                    _vm.addableTypesOpen
                      ? _c(
                          "div",
                          {
                            staticClass: "pdp-grid__add-dropdown-menu",
                            class: {
                              "pdp-grid__add-dropdown-menu--down":
                                _vm.dropdownOpensDown,
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "pdp-grid__add-dropdown-header" },
                              [
                                _vm._v(
                                  "\n            Add more to this set\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.addableTypes, function (t) {
                              return _c(
                                "button",
                                {
                                  key: t.key,
                                  staticClass: "pdp-grid__add-item",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addType(t.key)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "bi bi-plus-lg" }),
                                  _vm._v(
                                    " " + _vm._s(t.label) + "\n          "
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.configuringTile && _vm.configOpen
      ? _c(
          "div",
          {
            staticClass: "pdp-grid__configure-overlay",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) return null
                _vm.configOpen = false
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "pdp-grid__configure",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c("div", { staticClass: "pdp-grid__configure-head" }, [
                  _c("span", { staticClass: "pdp-grid__configure-title" }, [
                    _c("i", { staticClass: "bi bi-magic" }),
                    _vm._v(
                      " New image — " +
                        _vm._s(_vm.configuringTile.label) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "pdp-grid__configure-optional" }, [
                    _vm._v("All optional"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "pdp-grid__configure-close",
                      attrs: { type: "button", "aria-label": "Close" },
                      on: {
                        click: function ($event) {
                          _vm.configOpen = false
                        },
                      },
                    },
                    [_c("i", { staticClass: "bi bi-x-lg" })]
                  ),
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "pdp-grid__configure-label" }, [
                  _vm._v("Direction"),
                ]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.configDirection,
                      expression: "configDirection",
                    },
                  ],
                  staticClass: "pdp-grid__configure-text",
                  attrs: {
                    rows: "3",
                    placeholder: 'e.g. "warm afternoon kitchen, soft shadows"',
                  },
                  domProps: { value: _vm.configDirection },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.configDirection = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "pdp-grid__configure-row" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "pdp-grid__configure-modes" }, [
                    _c(
                      "button",
                      {
                        staticClass: "pdp-grid__configure-mode",
                        class: {
                          "is-active": _vm.configOverlayMode === "editable",
                        },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.configOverlayMode = "editable"
                          },
                        },
                      },
                      [_vm._v("\n            Editable\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "pdp-grid__configure-mode",
                        class: {
                          "is-active":
                            _vm.configOverlayMode === "part_of_image",
                        },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.configOverlayMode = "part_of_image"
                          },
                        },
                      },
                      [_vm._v("\n            Baked in\n          ")]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.configOverlayText,
                      expression: "configOverlayText",
                    },
                  ],
                  staticClass: "pdp-grid__configure-text",
                  attrs: { rows: "2", placeholder: 'e.g. "Now 20% off"' },
                  domProps: { value: _vm.configOverlayText },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.configOverlayText = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "pdp-grid__configure-tabs" }, [
                  _c(
                    "button",
                    {
                      staticClass: "pdp-grid__configure-tab",
                      class: { "is-active": _vm.configTab === "products" },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.configTab = "products"
                        },
                      },
                    },
                    [
                      _vm._v("\n          Product images\n          "),
                      _vm.configProducts.length
                        ? _c("span", {
                            staticClass: "pdp-grid__configure-tab-dot",
                          })
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "pdp-grid__configure-tab",
                      class: { "is-active": _vm.configTab === "refs" },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.configTab = "refs"
                        },
                      },
                    },
                    [
                      _vm._v("\n          Reference images\n          "),
                      _vm.configRefs.length
                        ? _c("span", {
                            staticClass: "pdp-grid__configure-tab-dot",
                          })
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "pdp-grid__configure-tab",
                      class: { "is-active": _vm.configTab === "logo" },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.configTab = "logo"
                        },
                      },
                    },
                    [
                      _vm._v("\n          Brand logo\n          "),
                      _vm.configLogo
                        ? _c("span", {
                            staticClass: "pdp-grid__configure-tab-dot",
                          })
                        : _vm._e(),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm.configTabImages.length
                  ? _c(
                      "div",
                      { staticClass: "pdp-grid__configure-refs" },
                      _vm._l(_vm.configTabImages, function (img, imgIdx) {
                        return _c(
                          "span",
                          {
                            key: `${_vm.configuringTile.rowIndex}-${_vm.configTab}-${imgIdx}`,
                            staticClass: "pdp-grid__configure-ref",
                          },
                          [
                            _c("img", {
                              attrs: { src: img, alt: _vm.configTabLabel },
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "pdp-grid__configure-ref-remove",
                                attrs: {
                                  type: "button",
                                  "aria-label": `Remove ${_vm.configTabLabel}`,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeConfigImage(
                                      _vm.configTab,
                                      imgIdx
                                    )
                                  },
                                },
                              },
                              [_c("i", { staticClass: "bi bi-x-lg" })]
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "pdp-grid__configure-drop",
                    class: {
                      "is-dragover": _vm.configDragSlot === _vm.configTab,
                    },
                    on: {
                      dragenter: function ($event) {
                        $event.preventDefault()
                        _vm.configDragSlot = _vm.configTab
                      },
                      dragover: function ($event) {
                        $event.preventDefault()
                        return _vm.onConfigDragOver(_vm.configTab, $event)
                      },
                      dragleave: function ($event) {
                        return _vm.onConfigDragLeave($event)
                      },
                      drop: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.onConfigDrop(_vm.configTab, $event)
                      },
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "pdp-grid__configure-link",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.pickConfigImagesFromComputer(
                              _vm.configTab
                            )
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "bi bi-upload" }),
                        _vm._v(
                          " " + _vm._s(_vm.configUploadLabel) + "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "pdp-grid__configure-sep" }, [
                      _vm._v("·"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "pdp-grid__configure-link",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.pasteConfigImage(_vm.configTab)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "bi bi-clipboard" }),
                        _vm._v(" Paste\n        "),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "pdp-grid__configure-sep" }, [
                      _vm._v("·"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "pdp-grid__configure-link",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.act(
                              `pdp_grid_configure_${_vm.configTabAction}:${_vm.configuringTile.rowIndex}`
                            )
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "bi bi-folder2-open" }),
                        _vm._v(" Choose from Files\n        "),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "pdp-grid__configure-foot" }, [
                  _c(
                    "button",
                    {
                      staticClass: "pdp-grid__configure-generate",
                      attrs: { type: "button" },
                      on: { click: _vm.generateConfigured },
                    },
                    [
                      _c("i", { staticClass: "bi bi-stars" }),
                      _vm._v(" Generate image\n        "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "pdp-grid__configure-remove",
                      attrs: { type: "button" },
                      on: { click: _vm.removeConfiguredTile },
                    },
                    [_vm._v("\n          Remove\n        ")]
                  ),
                ]),
              ]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.lightboxTile
      ? _c(
          "div",
          {
            staticClass: "pdp-grid__lightbox",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) return null
                return _vm.closeLightbox.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "button",
              {
                staticClass: "pdp-grid__lightbox-download",
                attrs: { type: "button", title: "Download image" },
                on: { click: _vm.downloadLightboxImage },
              },
              [_c("i", { staticClass: "bi bi-download" })]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "pdp-grid__lightbox-close",
                attrs: { type: "button" },
                on: { click: _vm.closeLightbox },
              },
              [_vm._v("\n      ✕\n    ")]
            ),
            _vm._v(" "),
            _vm.hasPrev
              ? _c(
                  "button",
                  {
                    staticClass:
                      "pdp-grid__lightbox-nav pdp-grid__lightbox-nav--prev",
                    attrs: { type: "button", title: "Previous image" },
                    on: { click: _vm.showPrev },
                  },
                  [_c("i", { staticClass: "bi bi-chevron-left" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasNext
              ? _c(
                  "button",
                  {
                    staticClass:
                      "pdp-grid__lightbox-nav pdp-grid__lightbox-nav--next",
                    attrs: { type: "button", title: "Next image" },
                    on: { click: _vm.showNext },
                  },
                  [_c("i", { staticClass: "bi bi-chevron-right" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "pdp-grid__lightbox-stage" }, [
              _c("img", {
                staticClass: "pdp-grid__lightbox-img",
                attrs: {
                  src: _vm.lightboxTile.url,
                  alt: _vm.lightboxTile.label,
                },
              }),
              _vm._v(" "),
              _vm.lightboxTile.overlayUrl
                ? _c("img", {
                    staticClass: "pdp-grid__lightbox-overlay",
                    attrs: { src: _vm.lightboxTile.overlayUrl, alt: "Product" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.lightboxTile._mrhiCallouts &&
              _vm.lightboxTile._mrhiCallouts.type === "cambridge"
                ? _c("div", { staticClass: "pdp-grid__lightbox-callouts" }, [
                    _c(
                      "div",
                      { staticClass: "pdp-grid__lightbox-callout-flavor" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.lightboxTile._mrhiCallouts.flavorText) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pdp-grid__lightbox-callout-count" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.lightboxTile._mrhiCallouts.countText) +
                            "\n        "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "pdp-grid__configure-label" }, [
      _c("i", { staticClass: "bi bi-file-text" }),
      _vm._v(" Overlay text\n        "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }